<template>
  <Dropdown :hideArrow="true" :hasTooltip="true" tooltipType="page" ref="dropdown" pclass bclass="btn-block gp_dropdown-button action" :positioning="positioning" lclass>
    <template v-slot:button>
      <i>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.42631 8.79242C3.22109 8.84723 3.02711 8.95512 2.86612 9.11612C2.37796 9.60427 2.37796 10.3957 2.86612 10.8839C3.35427 11.372 4.14573 11.372 4.63388 10.8839C4.79488 10.7229 4.90277 10.5289 4.95758 10.3237C5.06894 9.90667 4.96105 9.44328 4.63388 9.11612C4.30672 8.78895 3.84333 8.68106 3.42631 8.79242Z" fill="#676767"/>
          <path d="M17.1339 10.8839C17.622 10.3957 17.622 9.60427 17.1339 9.11612C16.6457 8.62796 15.8543 8.62796 15.3661 9.11612C14.878 9.60427 14.878 10.3957 15.3661 10.8839C15.8543 11.372 16.6457 11.372 17.1339 10.8839Z" fill="#676767"/>
          <path d="M10.8839 9.11612C11.372 9.60427 11.372 10.3957 10.8839 10.8839C10.3957 11.372 9.60427 11.372 9.11612 10.8839C8.62796 10.3957 8.62796 9.60427 9.11612 9.11612C9.60427 8.62796 10.3957 8.62796 10.8839 9.11612Z" fill="#676767"/>
        </svg>
      </i>

      <Modal @cancel="closeModal" v-if="modalActive" :cClass="classModal" iClass="typo-icon-14" :mClass="bodyClassModal">
        <template #header>
          <p class="typo-heading20 typo-medium text-light-high" :class="{ 'text-danger': currentModal == 'delete' }">{{ titleModal }}</p>
        </template>
        <template #default>
          <!-- Body Delete -->
          <template v-if="currentModal == 'delete'">
            <div class="form-group">
              <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1" v-html="$t('generals.confirm.delete', { name: item.g_title })"></p>
              <label class="mb-1 typo-paragraph14 typo-regular-150 text-light-low" v-html="$t('generals.confirm.typeConfirm')"></label>
              <input placeholder="Type here" ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="retypeDelete" />
              <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
            </div>
          </template>

          <!-- Body Rename -->
          <template v-if="currentModal == 'rename'">
            <div class="col-12 p-0">
              <div class="form-group">
                <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.pageName") }}</label>
                <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="pageName" :placeholder="$t('generals.pageName')" />
                <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
              </div>
            </div>
          </template>

          <!-- Body Duplicate -->
          <template v-if="['duplicate'].includes(currentModal)">
            <p class="typo-paragraph14 typo-regular-150 text-light-low">
              <span>{{ $t("generals.confirm.duplicate") }}</span>
              &nbsp;<span class="text-dark4">“{{ item.g_title }}”</span>?
            </p>
          </template>
        </template>
        <template #footer>
          <div class="btn-group flex-row-reverse row">
            <!-- Footer -->
            <template v-if="['rename', 'settings', 'duplicate'].includes(currentModal)">
              <div class="col-5 pl-1">
                <button class="btn btn-default btn-block btn-primary" @click="doSubmit">{{ textSubmitButton }}</button>
              </div>
              <div class="col-5 pr-0">
                <button class="btn btn-default btn-block btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
              </div>
            </template>

            <template v-if="currentModal == 'delete'">
              <div class="col-5 pl-1">
                <button class="btn btn-default btn-block btn-danger" @click="doSubmit">{{ textSubmitButton }}</button>
              </div>
              <div class="col-5 pr-0">
                <button class="btn btn-default btn-block btn-outline-danger" @click="closeModal">{{ $t("generals.cancel") }}</button>
              </div>
            </template>
          </div>
        </template>
      </Modal>
    </template>

    <a class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disable.includes('edit') }" :href="item.edit_url" target="_blank" :disabled="disable.includes('edit')" @click="closeDropdown" v-if="options.includes('edit')">
      <i class="icon icon-edit typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.edit") }}</p>
    </a>

    <div class="gp_dropdown-setting d-flex align-items-center gp_dropdown-setting-border-bottom" :class="{ disabled: disable.includes('use') }" @click.stop="!disable.includes('use') ? useThis : null" v-if="options.includes('use')">
      <i class="icon icon-check-circle typo-icon-16 text-mono3"></i>
      <p class="typo-button14 text-mono3 ml-1">{{ $t("analytic.ab.useThis") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disable.includes('rename') }" @click.stop="!disable.includes('rename') ? openModal('rename') : null" v-if="options.includes('rename')">
      <i class="icon icon-rename typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.rename") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disable.includes('duplicate') }" @click.stop="!disable.includes('duplicate') ? openModal('duplicate') : null" v-if="options.includes('duplicate')">
      <i class="icon icon-duplicate typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.duplicate") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disable.includes('changeVariant') }" @click.stop="!disable.includes('changeVariant') ? openChangeVariant() : null" v-if="options.includes('changeVariant')">
      <i class="icon icon-switch typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("analytic.ab.changeVar") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" :class="{ disabled: disable.includes('delete') }" @click.stop="!disable.includes('delete') ? openModal('delete') : null" v-if="options.includes('delete')">
      <i class="icon icon-delete typo-icon-16 text-danger"></i>
      <p class="typo-button14 ml-1 text-danger">{{ $t("generals.delete") }}</p>
    </div>
  </Dropdown>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types.js";
import errorHandle from "@/mixins/errorHandle.js";
export default {
  name: "PageReportDropdown",
  components: {},
  mixins: [errorHandle()],
  props: {
    cID: [String, Number],
    item: Object,
    positioning: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => ["edit", "rename", "duplicate", "changeVariant", "delete"]
    }
  },
  data() {
    return {
      modalActive: false,
      currentModal: "",
      reportActive: false,

      pageName: "",
      duration: 7,
      autoPublish: false,

      copied: false,
      alertText: "",
      retypeDelete: ""
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),

    bodyClassModal() {
      return "p-4 pt-3";
    },
    classModal() {
      return "mw222";
    },
    titleModal() {
      switch (this.currentModal) {
        case "delete":
          return this.$t("generals.delete");
        case "rename":
          return this.$t("generals.rename");
        case "duplicate":
          return this.$t("generals.duplicate");
      }
      return "";
    },
    textSubmitButton() {
      switch (this.currentModal) {
        case "delete":
          return this.$t("generals.delete");
        case "rename":
          return this.$t("generals.save");
        case "duplicate":
          return this.$t("generals.duplicate");
      }
      return "";
    }
  },
  watch: {},
  created() {
    this.pageName = this.item.g_title;
  },
  methods: {
    ...mapActions("analytic", {
      removePage: actions.DELETE_VARIANT_ANALYTIC,
      updatePage: actions.UPDATE_VARIANT_ANALYTIC,
      clonePage: actions.CLONE_PAGE_ANALYTIC
    }),
    doSubmit() {
      switch (this.currentModal) {
        case "delete":
          this.deletePage();
          break;
        case "rename":
          this.renamePage();
          break;
        case "duplicate":
          this.duplicatePage();
          break;
      }
      return "";
    },
    closeDropdown() {
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
    },
    openModal(modalType) {
      this.closeDropdown();
      this.currentModal = modalType;
      this.modalActive = true;
    },
    closeModal(userClose = true) {
      this.alertText = "";
      if (userClose) {
        this.pageName = this.item.g_title;
        this.retypeDelete = "";
      }
      this.modalActive = false;
    },
    deletePage() {
      let deleteTextConfirm = "confirm";
      if (this.$i18n.locale == "fr") {
        deleteTextConfirm = "confirmer";
      }
      if (this.retypeDelete.trim() != deleteTextConfirm) {
        this.alertText = this.$t("generals.confirm.retypeIncorrect");
        return;
      }
      this.retypeDelete = "";
      this.closeDropdown();
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      let textSuccess = this.$t("status.success");
      this.removePage({ campaignID: this.cID, variantID: this.item.g_id })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        });
    },
    renamePage() {
      this.alertText = "";
      let name = this.pageName.trim();
      if (!name || !name.length) {
        this.alertText = this.$t("analytic.ab.titleNotEmpty");
        return;
      }
      this.closeDropdown();
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      let textSuccess = this.$t("status.success");
      this.updatePage({ campaignID: this.cID, variantID: this.item.g_id, data: { data: { gTitle: this.pageName } } })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        });
    },
    openChangeVariant() {
      this.$emit("changeVariant", this.item);
    },
    duplicatePage() {
      this.closeDropdown();
      this.closeModal(false);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      let msgSuccess = this.$t("status.success");
      let msgError = this.$t("status.error");
      this.clonePage({
        campaignID: this.cID,
        page: this.item,
      })
        .then(page => {
          if (this && this.gSnackbarCommit && this.$t) {
            this.gSnackbarCommit({
              message: msgSuccess,
              type: "success"
            });
          }
          this.$emit("duplicate", page);
        })
        .catch(() => {
          this.gSnackbarCommit({
            message: msgError,
            type: "error"
          });
        });
    },
    useThis() {
      this.$emit("use", this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.gp_dropdown {
  &:not(.initiating) {
    ::v-deep .gp_dropdown-button {
      width: 40px;
      height: 40px;
      padding: unset;
      background: $light2;
      color: $textLightModeLow;
      i {
        margin: unset;
      }
      &:hover {
        background: $textDarkModeHigh;
        color: $textLightModeHigh;
        i {
          color: inherit;
        }
      }
    }
  }
}

::v-deep .gp_base-select_container {
  background: $light1;
}

::v-deep .gp_dropdown_list {
  width: 228px !important;
  margin-top: 10px;

  .disabled{
    pointer-events: none;
  }
}

.break-word {
  word-break: break-word;
}

.warn-info {
  background: rgba($mono1, 0.1);
}

.objective {
  background: $light1;
  border-radius: $radius;
  border: 2px solid $light1;
  color: $textLightModeLow;
  @include trans-all;
  $size: 110px;
  width: $size;
  height: $size;
  @include flex-center;
  flex-direction: column;
  cursor: pointer;
  padding: 8px;
  position: relative;
  .obj-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
  }

  .obj-text {
    margin-top: auto;
  }

  &:hover,
  &.active {
    border-color: $mono3;
    color: $mono3;
  }

  &.active:before {
    content: "\e94b";
    font-family: "gemicon";
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $textLightModeHigh;
    position: absolute;
    right: -10px;
    top: -10px;
    background: #fff;
    border-radius: 50%;
    font-size: 20px;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.spinning {
  animation-name: spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
